import React from "react"
import thrustmain from "../imgs/thrustmain.png"
import "./allinfo.css"

const Thrustinfo=()=>{
	return(
			<div>
			<div>
			<img src={thrustmain} className="thrustmain" alt="thrustmain"/>
			<div className="liftdiv"><p>
<strong>Thrust</strong> is the force which moves an aircraft through the air. Thrust is generated by the engines of the airplane. </p>

TThe physics involved in the generation of thrust is introduced in middle school and studied in some detail in high school and college. To accelerate the gas, we have to expend energy. The energy is generated as heat by the combustion of some fuel. The thrust equation describes how the acceleration of the gas produces a force. The propulsion system used on an aircraft may vary from airplane to airplane and each device produces thrust in a slightly different way. We will discuss four principal propulsion systems; the propeller, the turbine,or jet, engine, the ramjet, and the rocket.<br/>



			</div>
			</div>
			</div>
		);
}

export default Thrustinfo;